<template>
  <div>
    <app-header :style="styleTopVar"></app-header>
    <AppLeft :style="styleLeftVar"/>
    <!-- <app-main> </app-main> -->
    <AppRight :style="styleRightVar"/>
    <app-buttom :style="styleButtomVar"></app-buttom>
    <rose class="three3D" :style="threejsVar" />
  </div>
</template>


<script>
import rose from "@/components/ThreeJS/ThreeJS_Products_MaterialRack";
import AppHeader from "@/components/DataV/Layout/DataV_Layout_AppHeader";
import AppLeft from "@/components/DataV/Layout/DataV_Layout_AppLeft";
import AppRight from "@/components/DataV/Layout/DataV_Layout_AppRight";
import AppButtom from "@/components/DataV/Layout/DataV_Layout_AppButtom";

export default {
  //申明变量模块
  data() {
    return {
      fullHeight:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth, //必须写完,单写一种可能获取不到
      fullWidth:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,

      topHeight: this.fullHeight / 3,
      // bodyHeight: fullHeight / 7;
      bodyLeftWidth: 0,
      bodyRightWidht: 0,

      // bodyCenterWidth: fullWidth / 5;
      // bodyRightWidth: fullWidth / 2.5;
      // footHeight: fullHeight - topHeight - bodyHeight;
      styleTopVar: {
        "--line-height": "",
      },
      styleLeftVar: {
        "--top": "",
        "--width": "",
      },
      styleRightVar: {
        "--top": "",
        "--width": "",
      },
      threejsVar: {
        "--height": "",
      },
      styleButtomVar: {
        "--height": "",
        "--bottom": "",
      },
    };
  },
  //创建模块的时候
  created: function () {
    this.domInit();
  },
  //渲染模块APP
  components: {
    rose,
    AppHeader,
    AppLeft,
    // AppMain,
    AppRight,
    AppButtom,
  },
  //监听方法
  watch: {
    fullHeight(val) {
      //监控浏览器高度变化
      if (!this.timer) {
        this.fullHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },

  //方法申明模块
  methods: {
    get_bodyHeight() {
      //动态获取浏览器高度
      const that = this;
      window.onresize = () => {
        return (() => {
          window.fullHeight =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
          window.fullWidth =
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
          that.fullHeight = window.fullHeight;
          that.fullWidth = window.fullWidth;

          this.domInit();
          this.$nextTick();
        })();
      };
    },
    domInit() {
      this.bodyLeftWidth = this.fullWidth / 2.5;
      this.bodyRightWidht = this.bodyLeftWidth;
      this.topHeight = this.fullHeight / 20;
      //   this.fullHeight = this.fullHeight - 200;
      this.styleTopVar["--line-height"] = this.topHeight + "px";
      this.styleLeftVar["--top"] = this.topHeight + "px";
      this.styleRightVar["--top"] = this.topHeight + "px";

      this.styleLeftVar["--width"] = "22%";
      this.styleRightVar["--width"] = "22%";
      this.threejsVar["--height"] = this.fullHeight + "px";
      this.styleButtomVar["--height"] = "5%";
      this.styleButtomVar["--bottom"] = "-12%";
    },
  },

  //模板渲染成html后调用，通常是初始化页面完成后，再对html的dom节点进行一些需要的操作
  mounted() {
    this.get_bodyHeight();
    this.domInit();
  },
};
</script>
<style   scoped   >
.three3D {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -10;
  padding: 0;
  margin: 0;
  margin-top: -0.5em;
  margin-left: -0.5em;
}
/* 头部样式 */
.header {
  position: absolute;
  line-height: var(--line-height);
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 10;
  width: 100%;

  /* background: rgba(255, 255, 255, 0.1); */
}
/* 底部样式 */
.buttom {
  position: absolute;
  bottom: var(--bottom);
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
}
/* 左侧样式 */
.navbar {
  position: absolute;
  width: var(--width);
  top: var(--top); /* 距离上面50像素 */
  left: 0px;
  bottom: var(--bottom);
  height: 100%;
  z-index: 10;

  /* background: rgba(255, 255, 255, 0.3); */
  /*  overflow-y: auto;当内容过多时y轴出现滚动条 */
}

/* 右侧样式 */
.navbarRight {
  position: absolute;
  width: var(--width);
  height: 100%;
  top: var(--top); /* 距离上面50像素 */
  right: 0px;
  bottom: 0px;
  z-index: 10;
  /*overflow-y: auto; 当内容过多时y轴出现滚动条 */
 
  /* background: rgba(255, 255, 255, 0.5); */
}

/* 主区域 */
</style>